import * as React from 'react';

import * as styles from './amount-input.less';

type AmountInputProps = {
	value: number;
	onBlur?: () => void;
	onChange: (value: number) => void;
	ariaInvalid: boolean;
};

export const AmountInput: React.FC<AmountInputProps> = ({ value, onChange, onBlur, ariaInvalid }) => {
	return (
		<input
			className={styles.input}
			type="number"
			value={value.toString()}
			onBlur={onBlur}
			aria-required
			aria-invalid={ariaInvalid}
			aria-label="Amount"
			onChange={(ev) => {
				const value = +(ev.target.value || '0');
				if (Number.isNaN(value)) {
					return;
				}
				const decimals = value.toString().split('.')[1];
				if (decimals && decimals.length > 2) {
					return;
				}
				onChange(value);
			}}
		/>
	);
};
